
<div class="control-panel">
  <row class="panel-title">
    <column>
      <h4 class="dark">
        Control Panel
      </h4>
    </column>
    <suffix>
      <button class="btn-icon gravel-to-blue collapse-toolbox" @click="panelCollapse()" type="button">
        <span class="sr-only">Collapse/Reveal Toolbox</span>
        <span class="icon arrow-double"></span>
      </button>
    </suffix>
  </row>

  <scroll-area class="panel">
    <control-group group-name="Relationship Types" list-style>
      <li v-for="item in control_groups">
        <button data-c-tooltip-class="control-panel-tooltip right"
                :data-c-tooltip="item.name"
                :aria-label="item.name"
                :data-type="item.type"
                :class="controlClasses"
                @mousedown.left="drag">
          <icon :class="item.icon"></icon>
          {{ item.name }}
        </button>
      </li>
    </control-group>
  </scroll-area>

  <create-relationship-modal
    v-if="modalStateFor(vueModalID.createObjectModelRelationship).isVisible"
    :index="vueModalID.createObjectModelRelationship"
    :object-model="{reference_name: objectModel.reference_name}"
    :reference-names-taken="referenceNames"
    :relation-type="dropData.relationType"
    :state="modalStateFor(vueModalID.createObjectModelRelationship)"
    @create="createRelation"
    @toggle-modal="hideModal(vueModalID.createObjectModelRelationship)"
  />
</div>
